/**
 * Identity Scope Composable
 * 把身分作用域 store 與「當下的 token」接起來，供資料來源登記 receiveNo、供領獎出口判定歸屬。
 * 契約見 spec/2026-10-19-reward-claim-identity-scope/design.md §5.2。
 *
 * 用法（資料來源）：
 *   const requestIdentity = captureRequestIdentity()   // 必須在 await 之前取
 *   const res = await $request.send(...)
 *   admit(requestIdentity, res.data.map((row) => row.receiveNo))
 *   if (!isRequestIdentityCurrent(requestIdentity)) return // user-scoped store：飛行中換了 token 就不寫入畫面
 */

import { useIdentityScopeStore } from '@/stores/auth/identityScope'
import { identityKey } from '@/utils/identityGuard'

export const useIdentityScope = () => {
  const store = useIdentityScopeStore()
  const { token } = useAuthToken()

  const captureRequestIdentity = () => identityKey(token.value)

  const admit = (requestIdentity, receiveNos) => {
    store.admit(requestIdentity, Array.isArray(receiveNos) ? receiveNos : [])
  }

  const isRequestIdentityCurrent = (requestIdentity) => requestIdentity === identityKey(token.value)

  const currentOwner = () => store.ownerOf(identityKey(token.value))

  // 該 receiveNo 是誰的：未登記 → isAdmitted=false；登記者的 token 尚未確認 → owner=null
  const sourceOf = (receiveNo) => {
    const tokenKey = store.admissionOf(receiveNo)
    return { isAdmitted: tokenKey !== undefined, owner: tokenKey === undefined ? undefined : store.ownerOf(tokenKey) }
  }

  return {
    captureRequestIdentity,
    admit,
    isRequestIdentityCurrent,
    currentOwner,
    sourceOf,
  }
}
